/*
 * ARTSY FARTSY - Free shipping bar
 * Selvstaendig, app-fri progressbar for fri fragt.
 * Opdaterer sig selv naar kurven aendres (add / change / update / clear).
 */
(function () {
  'use strict';

  if (window.__afsFsbLoaded) return;
  window.__afsFsbLoaded = true;

  var SEL = '[data-afs-fsb]';
  var cartCache = null;
  var busy = false;
  var timer = null;

  /* ---------- Penge-formatering ----------
   * Vi udleder formatet fra en server-renderet prove ({{ 123456 | money }}),
   * saa JS formaterer praecis som Liquid - ogsaa i andre valutaer/markeder.
   */
  function buildFormatter(sample) {
    var fallback = function (cents) { return (cents / 100).toFixed(2); };
    if (!sample) return fallback;

    var match = sample.match(/\d[\d.,\s '’]*\d|\d/);
    if (!match) return fallback;

    var num = match[0];
    var prefix = sample.slice(0, match.index);
    var suffix = sample.slice(match.index + num.length);

    var decSep = '';
    var decimals = 0;
    var dec = num.match(/([.,])(\d{2})$/);
    if (dec) {
      decSep = dec[1];
      decimals = 2;
      num = num.slice(0, num.length - 3);
    }

    var thouSep = '';
    var thou = num.match(/[.,\s '’]/);
    if (thou) thouSep = thou[0];

    return function (cents) {
      var negative = cents < 0;
      var abs = Math.abs(cents);
      var whole = decimals ? Math.floor(abs / 100) : Math.round(abs / 100);
      var out = String(whole);
      if (thouSep) out = out.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
      if (decimals) {
        var frac = String(abs % 100);
        if (frac.length < 2) frac = '0' + frac;
        out += decSep + frac;
      }
      return (negative ? '-' : '') + prefix + out + suffix;
    };
  }

  var formatters = {};
  function getFormatter(el) {
    var sample = el.getAttribute('data-money-sample') || '';
    if (!formatters[sample]) formatters[sample] = buildFormatter(sample);
    return formatters[sample];
  }

  /* ---------- Undtagelser ---------- */
  function cartIsExcluded(el, cart) {
    var raw = (el.getAttribute('data-hide-match') || '').trim();
    if (!raw || !cart || !cart.items) return false;
    var needles = raw.toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!needles.length) return false;

    return cart.items.some(function (item) {
      var haystack = [item.handle, item.product_type, item.vendor, item.product_title]
        .join(' ')
        .toLowerCase();
      return needles.some(function (n) { return haystack.indexOf(n) !== -1; });
    });
  }

  /* ---------- Rendering ---------- */
  function renderOne(el, cart) {
    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
    if (!threshold) { el.hidden = true; return; }

    if (cartIsExcluded(el, cart)) { el.hidden = true; return; }

    var total = cart && typeof cart.total_price === 'number'
      ? cart.total_price
      : parseInt(el.getAttribute('data-total'), 10) || 0;

    var format = getFormatter(el);
    var remaining = threshold - total;
    // Minimum 10 % udfyldt, saa baren altid er visuelt tydelig
    var pct = Math.max(10, Math.min(100, (total / threshold) * 100));

    var textEl = el.querySelector('[data-afs-fsb-text]');
    var fillEl = el.querySelector('[data-afs-fsb-fill]');
    var message;

    if (remaining <= 0) {
      message = el.getAttribute('data-msg-success') || '';
      el.classList.add('afs-fsb--complete');
    } else {
      message = (el.getAttribute('data-msg-pending') || '')
        .replace(/\{\{\s*remaining_amount\s*\}\}/g, format(remaining));
      el.classList.remove('afs-fsb--complete');
    }

    if (textEl && textEl.textContent !== message) textEl.textContent = message;
    if (fillEl) {
      var width = pct.toFixed(1) + '%';
      if (fillEl.style.width !== width) fillEl.style.width = width;
    }

    el.setAttribute('data-total', String(total));
    el.setAttribute('aria-valuenow', String(Math.round(pct)));
    el.hidden = false;
  }

  function renderAll(cart) {
    busy = true;
    try {
      var nodes = document.querySelectorAll(SEL);
      for (var i = 0; i < nodes.length; i++) renderOne(nodes[i], cart);
    } finally {
      setTimeout(function () { busy = false; }, 0);
    }
  }

  /* ---------- Kurv-data ---------- */
  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart.js';
  }

  function refresh() {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartCache = cart; renderAll(cart); })
      .catch(function () { /* stille fejl - baren beholder sin serverside-vaerdi */ });
  }

  function refreshSoon() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 120);
  }

  /* ---------- Triggere ---------- */
  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.cart && typeof e.detail.cart.total_price === 'number') {
      cartCache = e.detail.cart;
      renderAll(e.detail.cart);
    } else {
      refreshSoon();
    }
  });
  document.addEventListener('cart:item-added', refreshSoon);
  document.addEventListener('quick-cart:open', refreshSoon);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshSoon(); });

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var promise = originalFetch.apply(this, arguments);
      try {
        var first = arguments[0];
        var url = typeof first === 'string' ? first : (first && first.url) || '';
        if (CART_RE.test(url)) promise.then(refreshSoon, function () {});
      } catch (err) { /* noop */ }
      return promise;
    };
  }

  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (CART_RE.test(String(url))) {
          this.addEventListener('load', refreshSoon);
        }
      } catch (err) { /* noop */ }
      return open.apply(this, arguments);
    };
  }

  /* Sektioner der gen-renderes (fx kurv-siden) skal fanges igen */
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      if (busy) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches(SEL)) || (node.querySelector && node.querySelector(SEL))) {
            renderAll(cartCache);
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() { renderAll(cartCache); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
